<div class="flex flex-col items-center">
  @if (titulo()) {
    <label class="text-xs text-slate-500 mb-1">{{ titulo() }}</label>
  }
  <div class="flex items-center gap-1">
    <button class="border border-slate-300 rounded-md px-0.5 hidden xl:block hover:bg-slate-50 transition-colors" (click)="decrementar()">
      <i class="bi bi-dash text-slate-500"></i>
    </button>
    <input
      type="number"
      [value]="cantidadFinal()"
      [min]="min()"
      [max]="max()"
      (input)="onCantidadChange($event)"
      [step]="step()"
      class="w-16 px-2 py-1 border border-slate-200 rounded-lg text-right text-slate-700 bg-slate-50 focus:outline-none focus:ring-2 focus:ring-accent-500/20 focus:border-accent-500 text-sm"
    />
    <button class="border border-slate-300 rounded-md px-0.5 hidden xl:block hover:bg-slate-50 transition-colors" (click)="incrementar()">
      <i class="bi bi-plus text-slate-500"></i>
    </button>
  </div>
</div>
